<div class="align-items-center">

    @if(roleEndedInfo.position.presumptive && roleEndedInfo.position.presumptive.status === presumptiveStatus.DENIED){
        <div class="col-12 mb-3 p-0">
             Your position on <b>{{roleEndedInfo?.project?.codeName}}</b>, <b>{{roleEndedInfo?.role?.roleType}}</b> has ended. Thank you for your efforts. Please verify your time records and rate your experience on the project.
        </div>
        @if(endMessage.length){
           <div class="col-12 mb-3 p-0">
               <p><b> {{reasonTitle}}: </b> <br /> {{endMessage}}</p>
           </div>
       }
        @if(hasTsheet){
            <div class="col-12 mb-3 p-0">
                Do you certify that your time records are accurate? 
            </div>
        }
    } @else {
        <div>
            {{'Placement Update' | sentenceCase}}
        </div>
    }

    @if(!roleEndedInfo.position.presumptive || (roleEndedInfo.position.presumptive && roleEndedInfo.position.presumptive.status !== presumptiveStatus.DENIED)){
        <div class="col-12 mb-3 p-0">
            {{'Role Ended' | sentenceCase}}
        </div>
    }

    @if(roleEndedInfo.position.presumptive && roleEndedInfo.position.presumptive.status === presumptiveStatus.DENIED){
        <div class="col-12 mb-3 p-0">
            <p>Thank you for submitting your profile for project: <b>{{roleEndedInfo?.project?.codeName}}</b>. Unfortunately the client will not be needing you on this project at this time.</p>
        </div>
    }
    @if(!roleEndedInfo.position.presumptive || (roleEndedInfo.position.presumptive && roleEndedInfo.position.presumptive.status !== presumptiveStatus.DENIED)){
        <div class="col-12 mb-3 p-0">
            <p>Your role: <b>{{roleEndedInfo?.role?.roleType}}</b> on project <b>{{roleEndedInfo?.project?.codeName}}</b> has been cancelled. Please click the "OK" button to begin receiving offers for new projects.</p>
        </div>
    }

    @if(endMessage.length){
        <div class="col-12 mb-3 p-0">
            <p><b> {{reasonTitle}} </b> <br /> {{endMessage}}</p>
        </div>
    }

    @if(roleStarted && hasTsheet){
        <div class="flex justify-content-end gap-2">
            <p-button [label]="gotoInvoiceText" (click)="confirm(false)" />
            <p-button label="ok" (click)="confirm(true)" />
        </div>
    }

    @if(!roleStarted || !hasTsheet){
        <div class="flex justify-content-end gap-2">
            <p-button label="ok" (click)="confirm(true)" />
        </div>
    }
</div>